import { initials as initialsOf } from '../../shared/text.js';
import { avatarSlot } from './avatar-colour.js';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps {
  /** The person's name; drives the initials and the accessible name. */
  name: string;
  email?: string | null;
  /**
   * Stable identifier for the colour hash — the subject id where known, so a renamed person
   * keeps their colour. Falls back to the email, then the name.
   */
  hashKey?: string | null;
  /** Pre-computed initials (e.g. from /api/me); otherwise derived. */
  initials?: string;
  size?: AvatarSize;
  /** Decorative repeat within a row that already names the person (03-components §14). */
  decorative?: boolean;
  className?: string;
}

/** Initials on a hash-derived tint (03-components §14). Never a photograph in the top bar. */
export function Avatar({ name, email, hashKey, initials, size = 'md', decorative = false, className }: AvatarProps) {
  const text = initials ?? initialsOf(name, email ?? undefined);
  const slot = avatarSlot(hashKey ?? email ?? name);
  return (
    <span
      className={['avatar', `avatar--${size}`, className].filter(Boolean).join(' ')}
      data-slot={slot}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : name}
      aria-hidden={decorative || undefined}
    >
      <span className="avatar__initials" aria-hidden="true">{text}</span>
    </span>
  );
}
